import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser, FieldValueConverters } from './FieldValueConverters'
import NumberFormat from 'react-number-format'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

export const NumberBoxTypes = {
  Basic: 'Basic',
  Currency: 'Currency',
  Phone: 'Phone'
}

export class NumberBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string,
    defaultValue: pt.number
  })

  static defaultProps = {
    defaultValue: 0,
    type: NumberBoxTypes.Basic
  }

  renderBasic () {
    const { min, max, step, defaultValue, groupButton, groupLabel, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly }) => <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
          <input type='number' step={step || 1} min={min} max={max} disabled={loading || readonly} invalid={showError} name={`numberbasic${name}`}
            id={`numberbasic${name}`} className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')} onChange={onChange} value={value || defaultValue || 0} />
        </FieldLayoutGroup>
        }
      </FieldLayoutBox>
    )
  }

  renderNumberFormatValueChange (values) {
    const { input: { onChange } } = this.props
    onChange(values.floatValue)
  }

  renderCurrency () {
    const { min, max, step, readonly, defaultValue, testId, groupButton, groupLabel, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly }) => <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
          <NumberFormat thousandSeparator={true} prefix={'$'} displayType={readonly ? 'text' : 'input'} disabled={loading} invalid={showError} name={`numbercurrency${name}`}
            id={`numbercurrency${name}`} decimalScale={2} fixedDecimalScale
            className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')} onValueChange={this.renderNumberFormatValueChange.bind(this)} value={value}
            renderText={(v) => { return <input data-tid={testId} className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')} readOnly name={`view${name}`} id={`view${name}`} value={v} /> }} />
        </FieldLayoutGroup>
        }
      </FieldLayoutBox>
    )
  }

  renderPhone () {
    const { min, max, step, defaultValue, groupButton, groupLabel, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, testId, readonly }) => <FieldLayoutGroup groupButton={groupButton} groupLabel={groupLabel}>
          <NumberFormat disabled={loading} displayType={readonly ? 'text' : 'input'} invalid={showError} name={`numberphone${name}`}
            id={`numberphone${name}`} decimalScale={0}
            className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')} onValueChange={this.renderNumberFormatValueChange.bind(this)} value={value}
            format="(###) ###-####" mask="_" renderText={(v) => { return <input className={clsx(showError && 'is-invalid-input', (groupButton || groupLabel) && 'input-group-field')} data-tid={testId} readOnly name={`view${name}`} id={`view${name}`} value={v} /> }} />
        </FieldLayoutGroup>
        }
      </FieldLayoutBox>
    )
  }

  render () {
    const { type } = this.props

    if (_.isFunction(this[`render${type}`])) {
      return this[`render${type}`]()
    } else {
      return this.renderBasic()
    }
  }
};

export const NumberBox = ({ parse, format, fieldType = FieldValueConverters.Number, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={NumberBoxClass} /> } // eslint-disable-line
NumberBox.FormatTypes = NumberBoxTypes

export default NumberBox
